<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 让应用严格占满视口，避免 body 默认 margin 造成额外滚动与高度计算偏差 */
html,
body,
#app {
  height: 100%;
}

body {
  margin: 0;
  overflow: hidden;
}

/*
  全局：ElementUI 默认很多地方是单行省略（nowrap + ellipsis）。
  这里统一改为：内容超出时自动换行展示。
*/
.el-table .cell,
.el-table th .cell,
.el-table .cell.el-tooltip {
  white-space: normal;
  word-break: break-word;
}

.el-descriptions-item__content,
.el-form-item__content,
.el-dialog__body {
  white-space: normal;
  word-break: break-word;
}

/*
  管理端列表页通用布局：让表格区域随窗口高度自适应。
  配合 mixin `tableAutoHeight` 使用。
*/
.page-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.page-card--full {
  height: 100%;
  flex: 1;
  min-height: 0;
}

.page-card--full > .el-card__body {
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}


.page-card-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pager-bar {
  text-align: right;
}
</style>


